import { SampleInfo , TreeInfo } from './Utils';

const FAKE_TREE = {
  '0': [
    {text: 'chapter1\n\nchapter2', summary: 'a book', summarize_range: [0, 2]},
  ],
  '1': [
    {text: 'summ1\n\nsumm2', summary: 'chapter1', summarize_range: [0, 2]},
    {text: 'summ3\n\nsumm4', summary: 'chapter2', summarize_range: [2, 4]},
  ],
  '2': [
    {text: 'original text 1', summary: 'summ1', summarize_range: null},
    {text: 'original text 2', summary: 'summ2', summarize_range: null},
    {text: 'original text 3', summary: 'summ3', summarize_range: null},
    {text: 'original text 4', summary: 'summ4', summarize_range: null},
  ],
};

export async function fetch_data(type: string, dataset: string, n_shards: number, data_id: any | null) {
  if (dataset === "gutenberg") {
    let results =  await fetch_gutenberg_data(data_id, "gutenberg")
    return {
      results: results as any,
      dataset: dataset,
    };
  } else if (dataset === "booksum") {
    let results =  await fetch_gutenberg_data(data_id, "booksum")
    return {
      results: results as any,
      dataset: dataset,
    };
  } else if (dataset === "narrativeqa") {
    let results =  await fetch_narrativeqa_data(data_id)
    return {
      results: results as any,
      dataset: dataset,
    };
  } else if (dataset === "goodreads") {
    let results =  await fetch_goodreads_data()
    return {
      results: results as any,
      dataset: dataset,
    };
  }
  let result: Array<SampleInfo>;
  // if (process.env.NODE_ENV === 'development') {
  if (false) {
    result = [
      {
        info: {text: 'foo'},
        samples: {
          policy1: 'A sample from policy 1',
          policy2: 'A sample from policy 2',
        },
      },
      {
        info: {text: 'bar'},
        samples: {
          policy1: 'Another sample from policy 1',
          policy2: 'Another sample from policy 2',
        },
      },
    ];
  } else {
    try {
      let shard = Math.floor(Math.random() * n_shards);
      const response = await fetch(`data/${type}.${dataset}.${shard}.json`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        // body: JSON.stringify({
        // }),
      });
      result = (await response.json());
    } catch (e) {
      alert(e);
      throw e
    }
  }
  return {
    id: Math.random(),
    results: result as any,
    dataset: dataset,
  };
}


async function fetch_gutenberg_data(book_id: number, dataset: string): Promise<TreeInfo> {
  console.log("FETCHING", book_id)
  let result: any;
  if (false) {
    result = {
      info: {
        url: "",
      },
      tree: FAKE_TREE,
    };
  } else {
    try {
      const all_response = await fetch(`data/${dataset}_book_trees/${book_id}/all.json`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      let all_json = (await all_response.json());
      const info_response = await fetch(`data/${dataset}_book_trees/${book_id}/info.json`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      let info_json = (await info_response.json());
      result = {
        info: info_json,
        tree: all_json,
      }
    } catch (e) {
      alert(e);
      throw e
    }
  }
  return result;
}

async function fetch_narrativeqa_data(data_id: number): Promise<TreeInfo> {
  console.log("FETCHING", data_id)
  let result: any;
  if (false) {
    result = {
      preds: [
        {qa: {}, preds: {}}
      ],
      info: {
        url: "",
      },
      tree: FAKE_TREE
    };
  } else {
    try {
      const all_response = await fetch(`data/narrativeqa/${data_id}.json`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      result = (await all_response.json());
    } catch (e) {
      alert(e);
      throw e
    }
  }
  return result;
}

async function fetch_goodreads_data(): Promise<TreeInfo> {
  let result: any;
  if (false) {
    result = {
      preds: [
        {qa: {}, preds: {}}
      ],
      info: {
        url: "",
      },
      tree: FAKE_TREE
    };
  } else {
    try {
      const all_response = await fetch(`data/goodreads2020.json`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      result = (await all_response.json());
    } catch (e) {
      alert(e);
      throw e
    }
  }
  return result;
}
